import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/objectWithoutPropertiesLoose";
var _excluded = ["classes", "children", "disabled", "onClick", "isActive", "isLoading"];
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { default as withStyles } from '../../styles';
import ListItem from '../../List/ListItem';
import classNames from 'classnames';
import { withEDSContext } from '../../EDSContext/EDSContext';
import { colorCtaBlueBase, colorCtaBlueHover } from '../../styles/tokens';
var styles = function styles() {
  return {
    item: {
      outline: 'none',
      display: 'flex',
      cursor: 'pointer',
      color: colorCtaBlueBase,
      '& svg': {
        fill: colorCtaBlueBase
      },
      '&:active': {
        color: colorCtaBlueHover,
        '& svg': {
          fill: colorCtaBlueHover
        }
      },
      '&:hover': {
        color: colorCtaBlueHover,
        '& svg': {
          fill: colorCtaBlueHover
        }
      },
      '&:focus': {
        color: colorCtaBlueHover,
        '& svg': {
          fill: colorCtaBlueHover
        }
      }
    }
  };
};
var FooterItem = function FooterItem(props) {
  var classes = props.classes,
    childrenProp = props.children,
    disabled = props.disabled,
    onClick = props.onClick,
    isActive = props.isActive,
    isLoading = props.isLoading,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  var children = childrenProp;
  var itemRef = /*#__PURE__*/React.createRef();

  // disabling warning for missing dpendency of itemRef
  // refer to the following link for more details on why this is the best option for this case
  // https://stackoverflow.com/questions/55840294/how-to-fix-missing-dependency-warning-when-using-useeffect-react-hook
  useEffect(function () {
    if (isActive) {
      itemRef.current && itemRef.current.focus();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isActive]);
  return /*#__PURE__*/React.createElement(React.Fragment, null, !isLoading && /*#__PURE__*/React.createElement(ListItem, _extends({
    className: classNames(classes.item, props.className),
    disabled: disabled,
    "aria-disabled": disabled ? true : false,
    ref: itemRef,
    tabIndex: 0,
    onClick: onClick,
    button: true,
    role: "button",
    "data-id": "footerItem",
    "aria-label": children.props['aria-label'] || 'footerItem'
  }, rest), children));
};
FooterItem.displayName = 'FooterItem';
FooterItem.propTypes = {
  /**
   * The React element of the item.
   */
  children: PropTypes.node,
  /**
   * If `true`, the item will be disabled.
   */
  disabled: PropTypes.bool,
  /**
   * @ignore
   */
  classes: PropTypes.object,
  /**
   * @ignore
   */
  onClick: PropTypes.func,
  /**
   * @ignore
   */
  isActive: PropTypes.bool,
  /**
   * @ignore
   */
  className: PropTypes.string,
  /**
   * @ignore
   */
  isLoading: PropTypes.bool
};
export default withStyles(styles, {
  name: 'FooterItem'
})(withEDSContext(FooterItem));